/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { logAction } from '../../../utils/actionLogger'

/* COMPONENTS */
import { Image } from '../../../components/ui'

/* STORE */

/* STYLES */
import {
  MessageAvatarContainer,
  MayaMessageAvatar,
  MessageContainer,
  TextContainer,
  TypingDot,
  AiResponseTextContainer,
} from './style'

/* UTILS/CONSTANTS*/
import { CLIENT_STYLINGS } from '../../../utils/constants'
import {
  handleIncompleteMarkdownLinks,
  getTranslations,
  Analytics,
} from '../../../utils'

/* ASSETS */

const SearchAiTextResponse = ({
  organizationSlug,
  isTyping,
  textResponse,
  isTextExpanded,
  isLessThanLaptop,
  language,
}) => {
  const MayaAvatar = CLIENT_STYLINGS[organizationSlug].MAYA_AVATAR_URL

  const [formattedTextResponse, setFormattedTextResponse] = useState(
    handleIncompleteMarkdownLinks(textResponse)
  )

  useEffect(() => {
    setFormattedTextResponse(handleIncompleteMarkdownLinks(textResponse))
  }, [textResponse])

  return (
    <MessageContainer>
      {
        <MessageAvatarContainer>
          <MayaMessageAvatar
            src={MayaAvatar}
            alt='Message Avatar'
            width={'30px'}
            height={'30px'}
            objectFit={'contain'}
          />
        </MessageAvatarContainer>
      }
      <TextContainer isTyping={isTyping}>
        {isTyping ? (
          <>
            <TypingDot />
            <TypingDot />
            <TypingDot />
          </>
        ) : (
          <AiResponseTextContainer
            id='ai-response-text-container'
            $fullHeight={isTextExpanded || !isLessThanLaptop}
          >
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                a(props) {
                  // OPEN LINKS IN NEW TABS
                  const { node, href, ...rest } = props
                  return (
                    <a
                      {...rest}
                      href={href}
                      target='_blank'
                      onClick={e => {
                        Analytics.getInstance().sendEvent(
                          'maya_url_click_search',
                          {
                            item_url: href,
                            item_type: 'text',
                            item_title:
                              e.currentTarget.textContent?.trim() || undefined,
                          }
                        )
                        logAction({
                          name: 'url_click_search',
                          url: href,
                          linkLabel:
                            e.currentTarget.textContent?.trim() || undefined,
                        })
                      }}
                    />
                  )
                },
                p(props) {
                  // OPEN LINKS IN NEW TABS
                  const { node, ...rest } = props
                  return <p {...rest} />
                },
                ol(props) {
                  // OPEN LINKS IN NEW TABS
                  const { node, ...rest } = props
                  return <ol {...rest} />
                },
                ul(props) {
                  // OPEN LINKS IN NEW TABS
                  const { node, ...rest } = props
                  return (
                    <ul
                      style={{
                        color: CLIENT_STYLINGS[organizationSlug].COLOR.PAPER_00,
                        'font-size': '16px',
                        'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.SECONDARY}`,
                      }}
                      {...rest}
                    />
                  )
                },
              }}
            >
              {formattedTextResponse ||
                getTranslations('ai_search_query_response_placeholder')}
            </ReactMarkdown>
          </AiResponseTextContainer>
        )}
      </TextContainer>
    </MessageContainer>
  )
}

const mapStateToProps = state => ({
  organizationSlug: state.general.organizationSlug,
})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchAiTextResponse)
